// React
import React, { useState, createContext } from 'react'
import PropTypes from 'prop-types'

// Libraries
import { useFormikContext } from 'formik'

// Hooks
import { usePicker } from 'ui/components/Picker/hooks'

// Shared
import OperatingRuleUtils from 'shared/utils/operating_rules'

export const CalendarPageContext = createContext()

export const Picker = ({ components, ...props }) => {
  const picker = usePicker()
  const form = useFormikContext()

  const initializeFocusedDate = () => {
    if (form.values.starts_at) return new Date(form.values.starts_at)

    if (picker.type === 'cart') {
      const firstSelectable = OperatingRuleUtils.firstTimeSelectable()
      return firstSelectable?.toDate() || new Date()
    }

    return new Date()
  }

  const [focusedDate, setFocusedDate] = useState(initializeFocusedDate())

  // Default
  let Component = components.Free

  switch (picker.mode) {
    case 'timeslot_duration':
      Component = components.Durations
      break
    case 'timeslot_fixed':
      Component = components.Timeslots
      break
    default:
      Component = components.Free
      break
  }

  return (
    <CalendarPageContext.Provider value={{ focusedDate, setFocusedDate }}>
      <Component {...props} timeslots={picker.getSelectableTimeslots(form.values.starts_at)} />
    </CalendarPageContext.Provider>
  )
}

Picker.propTypes = {
  components: PropTypes.shape({
    Free: PropTypes.func,
    Durations: PropTypes.func,
    Timeslots: PropTypes.func
  })
}
